import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiOverviewCardModule } from '../lib/shared-ui-overview-card.module'
import { OverviewCardDocsComponent } from './overview-card-docs/overview-card-docs.component'
import { OverviewCardExampleComponent } from './overview-card-docs/overview-card-example.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiOverviewCardModule,
  ],
  declarations: [
    OverviewCardDocsComponent,
    OverviewCardExampleComponent
  ],
  exports: [
    OverviewCardDocsComponent
  ]
})
export class SharedUiOverviewCardDocsModule {}
